import api from "./apiConfig";

export const REGISTER_QUEJA = async (data) => {
	try {
		const response = await api.post("/incidentLog", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_QUEJA = async (id, data) => {
	try {
		const response = await api.put(`/incidentLog/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar:", error);
		throw error;
	}
};

export const GET_QUEJAS_REPORTES_ALL = async () => {
	try {
		const response = await api.get(`/incidentLog`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};